"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTimeString = exports.getTimeDigits = exports.getMeridiem = exports.formatSeconds = exports.formatTimeParts = exports.normalizeMeridiem = exports.getOppositeHour = exports.getTotalSeconds = exports.getTimePartsFromSeconds = exports.convertHour24hTo12h = exports.convertHour12hTo24h = void 0;
function convertHour12hTo24h({ hour, meridiem, }) {
    if (meridiem === 'am') {
        if (hour === 12)
            return 0;
        return hour;
    }
    if (hour !== 12)
        return hour + 12;
    return hour;
}
exports.convertHour12hTo24h = convertHour12hTo24h;
function convertHour24hTo12h({ hour }) {
    const meridiem = hour < 12 ? 'am' : 'pm';
    let hour12h = hour;
    if (hour === 0) {
        hour12h = 12;
    }
    else if (hour > 12) {
        hour12h = hour - 12;
    }
    return { hour: hour12h, meridiem };
}
exports.convertHour24hTo12h = convertHour24hTo12h;
function getTimePartsFromSeconds(seconds) {
    return {
        hour: Math.trunc(seconds / (60 * 60)),
        minute: (seconds / 60) % 60,
        second: seconds % 60,
    };
}
exports.getTimePartsFromSeconds = getTimePartsFromSeconds;
function getTotalSeconds({ hour, minute }) {
    return hour * 3600 + minute * 60;
}
exports.getTotalSeconds = getTotalSeconds;
function getOppositeHour(hour) {
    if (hour < 12)
        return hour + 12;
    return hour - 12;
}
exports.getOppositeHour = getOppositeHour;
function normalizeMeridiem(meridiem) {
    meridiem = meridiem.toLowerCase();
    // istanbul ignore next
    if (meridiem.length <= 2) {
        if (meridiem[0] === 'a')
            return 'am';
        if (meridiem[0] === 'p')
            return 'pm';
    }
    throw new Error(`Invalid meridiem: ${meridiem}`);
}
exports.normalizeMeridiem = normalizeMeridiem;
function formatTimeParts(timeParts, { hourFormat = '24-hour' } = {}) {
    let { hour, minute } = timeParts;
    let meridiem = '';
    if (hourFormat === '12-hour') {
        const result = convertHour24hTo12h({ hour });
        meridiem = result.meridiem;
        hour = result.hour;
    }
    const formattedHour = hourFormat === '12-hour' ? hour : hour.toString().padStart(2, '0');
    const formattedMinute = minute.toString().padStart(2, '0');
    return `${formattedHour}:${formattedMinute}${meridiem}`;
}
exports.formatTimeParts = formatTimeParts;
function formatSeconds(seconds, opts) {
    return formatTimeParts(getTimePartsFromSeconds(seconds), opts);
}
exports.formatSeconds = formatSeconds;
function getMeridiem(str) {
    var _a;
    const [meridiem] = (_a = /([ap]m?)$/i.exec(str)) !== null && _a !== void 0 ? _a : [];
    if (meridiem) {
        return normalizeMeridiem(meridiem);
    }
    return undefined;
}
exports.getMeridiem = getMeridiem;
function getTimeDigits(timeStr) {
    // remove any character that is not a number or a ":"
    timeStr = timeStr.replace(/[^\d:]/g, '');
    if (timeStr.length === 0)
        return null;
    if (timeStr.includes(':')) {
        if (timeStr.length > 5)
            return null;
        return timeStr.split(':').map((c) => c.slice(0, 2));
    }
    if (timeStr.length > 4)
        return null;
    // 1 and 3 digits = hMM
    // 2 and 4 digits = hhMM
    const hourUpperIndex = 2 - (timeStr.length % 2);
    return [
        timeStr.slice(0, hourUpperIndex),
        timeStr.slice(hourUpperIndex, hourUpperIndex + 2),
    ];
}
exports.getTimeDigits = getTimeDigits;
function parseTimeString(timeStr, hourFormat = '24-hour') {
    timeStr = timeStr.trim();
    const meridiem = getMeridiem(timeStr);
    const timeDigits = getTimeDigits(timeStr);
    if (timeDigits == null)
        return null;
    const [hourDigits, minuteDigits] = timeDigits;
    let hour = parseInt(hourDigits, 10);
    const minute = parseInt(minuteDigits, 10) || 0;
    if (Number.isNaN(hour) ||
        Number.isNaN(minute) ||
        hour > 23 ||
        hour < 0 ||
        minute < 0 ||
        minute > 59 ||
        ((meridiem || hourFormat === '12-hour') && hour > 12)) {
        return null;
    }
    if (meridiem) {
        hour = convertHour12hTo24h({ hour, meridiem });
    }
    if (hourFormat !== '12-hour') {
        return [{ hour, minute }];
    }
    const options = [{ hour, minute }];
    if (meridiem == null) {
        options.push({ hour: getOppositeHour(hour), minute });
    }
    return options.sort((a, b) => a.hour - b.hour);
}
exports.parseTimeString = parseTimeString;
